export const FEEDS = [
    () => import('~/components/EmailSubscription/EmailSubscription.vue'),
    // {
    //   id: 'googlenews',
    //   logo: () => import('~/assets/images/feeds/googlenews.svg?inline'),
    //   name: 'Google News',
    //   title: 'Подпишитесь на наши новости в Google News',
    //   to: '//news.google.com/publications/CAAqBwgKMOGy_gowocOKAw?ceid=RU:ru&oc=3',
    // },
    {
        id: 'youtube',
        logo: () => import('~/assets/images/feeds/youtube.svg?inline'),
        name: 'Youtube',
        title: 'Подпишитесь на наш YouTube-канал',
        to: '//www.youtube.com/c/ForbesRus',
    },
    {
        id: 'yandexnews',
        logo: () => import('~/assets/images/feeds/yandexnews.svg?inline'),
        name: 'Я.Новости',
        title: 'Подпишитесь на наши новости в Яндекс.Новости',
        to: '//dzen.ru/news?favid=13074&issue_tld=ru',
    },
    {
        id: 'zen',
        logo: () => import('~/assets/images/feeds/zen.svg?inline'),
        name: 'Дзен',
        title: 'Подпишитесь на наши новости в Дзен',
        to: '//dzen.ru/forbes.ru',
    },
    {
        id: 'telegram',
        logo: () => import('~/assets/images/feeds/telegram.svg?inline'),
        name: 'Telegram',
        title: 'Подпишитесь на нас в Telegram',
        to: '//t.me/forbesrussia',
    },
    {
        id: 'vk',
        logo: () => import('~/assets/images/feeds/vk.svg?inline'),
        name: 'VK',
        title: 'Подпишитесь на нас в VK',
        to: '//vk.com/forbes',
    },
    // {
    //   id: 'instagram',
    //   logo: () => import('~/assets/images/feeds/instagram.svg?inline'),
    //   name: 'Instagram',
    //   title: 'Подпишитесь на нас в Instagram',
    //   to: '//www.instagram.com/forbes.russia/',
    // },
    // {
    //   id: 'facebook',
    //   logo: () => import('~/assets/images/feeds/facebook.svg?inline'),
    //   name: 'Facebook',
    //   title: 'Подпишитесь на нас в Facebook',
    //   to: '//www.facebook.com/forbesrussia',
    // },
    {
        id: 'ok',
        logo: () => import('~/assets/images/feeds/ok.svg?inline'),
        name: 'OK',
        title: 'Подпишитесь на нас в Одноклассниках',
        to: '//ok.ru/forbes',
    },
    {
        id: 'twitter',
        logo: () => import('~/assets/images/feeds/twitter.svg?inline'),
        name: 'Twitter',
        title: 'Подпишитесь на нас в Twitter',
        to: '//twitter.com/forbesrussia',
    },
    // {
    //   id: 'tiktok',
    //   logo: () => import('~/assets/images/feeds/tiktok.svg?inline'),
    //   name: 'TikTok',
    //   title: 'Подпишитесь на нас в TikTok',
    //   to: '//www.tiktok.com/@forbesrus',
    // },
];
export const FEEDS_SPORT = [
    {
        id: 'zen',
        logo: () => import('~/assets/images/feeds/zen.svg?inline'),
        name: 'Яндекс.Дзен',
        title: 'Подпишитесь на Forbes Sport в Дзен',
        to: '//dzen.ru/forbessport',
    },
    {
        id: 'telegram',
        logo: () => import('~/assets/images/feeds/telegram.svg?inline'),
        name: 'Telegram',
        title: 'Подпишитесь на Telegram-канал Forbes Sport',
        to: '//t.me/forbessportrussia',
    },
    {
        id: 'vk',
        logo: () => import('~/assets/images/feeds/vk.svg?inline'),
        name: 'VK',
        title: 'Подпишитесь на Forbes Sport в VK',
        to: '//vk.com/forbessport',
    },
    {
        id: 'twitter',
        logo: () => import('~/assets/images/feeds/twitter.svg?inline'),
        name: 'Twitter',
        title: 'Подпишитесь на нас в Twitter',
        to: '//twitter.com/forbessport',
    },
];
export const FEEDS_WOMAN = [
    {
        id: 'telegram',
        logo: () => import('~/assets/images/feeds/telegram.svg?inline'),
        name: 'Telegram',
        title: 'Подпишитесь на Telegram-канал Forbes Woman',
        to: '//t.me/ForbesWomanRussia',
    },
    {
        id: 'vk',
        logo: () => import('~/assets/images/feeds/vk.svg?inline'),
        name: 'VK',
        title: 'Подпишитесь на Forbes Woman в VK',
        to: '//vk.com/forbes_woman',
    },
];
export const FEEDS_LIVE = [
    {
        id: 'telegram',
        logo: () => import('~/assets/images/feeds/telegram.svg?inline'),
        name: 'Telegram',
        title: 'Подпишитесь на Telegram-канал Forbes Life',
        to: '//t.me/ForbesLifeRussia',
    },
    {
        id: 'vk',
        logo: () => import('~/assets/images/feeds/vk.svg?inline'),
        name: 'VK',
        title: 'Подпишитесь на Forbes Life в VK',
        to: '//vk.com/forbes.life',
    },
];
export const FEEDS_YOUNG = [
    {
        id: 'telegram',
        logo: () => import('~/assets/images/feeds/telegram.svg?inline'),
        name: 'Telegram',
        title: 'Подпишитесь на Telegram-канал Forbes Young',
        to: '//t.me/forbes_young',
    },
    {
        id: 'vk',
        logo: () => import('~/assets/images/feeds/vk.svg?inline'),
        name: 'VK',
        title: 'Подпишитесь на Forbes Young в VK',
        to: ' //vk.com/forbes_young_russia',
    },
];
export const TYPES_FEEDS = {
    sport: FEEDS_SPORT,
    'forbes-woman': FEEDS_WOMAN,
    forbeslife: FEEDS_LIVE,
    forbesyoung: FEEDS_YOUNG,
    others: FEEDS,
};
